import { configureStore } from '@reduxjs/toolkit';
import adminActivitiesReducer from './adminActivitiesSlice.ts';
import adminCompaniesReducer from './adminCompaniesSlice.js';
import userActivitiesReducer from './userActivitiesSlice.js';
import userReducer from  './userSlice.js';
import adminShopReducer from './adminShopSlice.js';
import userShopReducer from './userShopSlice.js';
import scrollReducer from './scrollSlice.js';
import filtersReducer from './filtersSlice';
import searchbarReducer from './searchbarSlice.js';
import userMapReducer from './userMapActivities.js';
import galleryReducer from './gallerySlice.js';
import backlinkReducer from './backlinkSlice.js';
import cartReducer from './cartSlice.js';

const store = configureStore({
    reducer: {
        adminActivities: adminActivitiesReducer,
        adminCompanies: adminCompaniesReducer,
        userActivities: userActivitiesReducer,
        user: userReducer,
        adminShop: adminShopReducer,
        userShop: userShopReducer,
        scroll: scrollReducer,
        filters: filtersReducer,
        searchbar: searchbarReducer,
        userMapActivities: userMapReducer,
        gallery: galleryReducer,
        backlink: backlinkReducer,
        cart: cartReducer
    }
})

export default store;